import React from 'react';

import ModalsManager from 'containers/ModalsManager';

import styles from './Layout.module.scss';

import packageJson from '../../../../package.json';

export const Layout = (props: { children: React.ReactNode }) => {
    return (
        <main className={styles.mainWrap}>
            {props.children}
            <p className={styles.version}>v{packageJson.version}</p>
            <ModalsManager />
        </main>
    );
};
